import { Component, OnInit } from '@angular/core';
import { GeneralService } from '../../../core/services/general.service';

@Component({
  selector: 'app-alert',
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.scss'],
})
export class AlertComponent implements OnInit {
  message: any;
  type: any;
  actions: any;

  constructor(private GS: GeneralService) {}
  ngOnInit(): void {
    this.GS.currentNote.subscribe((note) => {
      if (!note) {
        this.message = '';
      } else {
        this.message = note.text;
        this.type = note.type;
        this.actions = note.actions;
        setTimeout(() => {
          this.message = '';
        }, note.duration);
      }
    });
  }

  hideNote() {
    this.GS.sendNote({});
  }
}
